/**
 * Created by rossd on 5/18/2018.
 */
import * as userActions from "./user"


export const ActionCreators = Object.assign({},
    userActions
)


// WEBPACK FOOTER //
// ./src/reducers/index.js